import React from "react"
import { Box, Typography, useTheme } from "@mui/material"
import { alpha } from "@mui/material/styles"
import { CardSeeker, CountUpSeeker, IconSeeker, LoadingIconSeeker } from "@ui-seeker/core"

import { dsColorNew } from "@palette"


// iconColor is a palette path such as "colors.green"; the tinted square needs the real colour
const paletteColor = (palette, path) => path?.split('.').reduce((node, key) => node?.[key], palette) || dsColorNew.webBlue500


export default function AppAnalyticsCard({ isLoading, iconColor, label, countUp, icon }) {
	const { palette } = useTheme()
	const color = paletteColor(palette, iconColor)

	return <CardSeeker
		sx={{
			width: "100%",
			height: "100%",
			containerType: 'inline-size',
			'&:hover': { transform: 'translateY(-2px)', borderColor: dsColorNew.webBlue500 },
			// A narrow card (side menu open on a small screen) shrinks icon and figure instead of cutting the figure
			'@container (max-width: 170px)': {
				'& .kpi-icon': { width: 34, height: 34, borderRadius: '10px' },
				'& .kpi-icon svg, & .kpi-icon i': { fontSize: 15 },
				'& .kpi-value': { fontSize: 21 },
				'& .MuiCardContent-root': { gap: 1, px: '12px !important' },
			},
		}}
		contentProps={{
			sx: { height: 1, display: 'flex', alignItems: 'center', gap: 1.75, p: '18px !important' }
		}}
	>
		<Box className="kpi-icon" sx={{
			width: 44, height: 44, borderRadius: '12px', flexShrink: 0,
			display: 'flex', alignItems: 'center', justifyContent: 'center',
			backgroundColor: alpha(color, 0.12),
		}}>
			{isLoading
				? <LoadingIconSeeker sx={{ color, fontSize: 19 }}/>
				: <IconSeeker icon={icon} sx={{ color, fontSize: 19 }}/>}
		</Box>

		<Box sx={{ minWidth: 0 }}>
			<Typography sx={{ fontSize: 11, fontWeight: 600, letterSpacing: 1, textTransform: 'uppercase', color: dsColorNew.textMuted }}>
				{label?.replace(/:$/, '')}
			</Typography>
			<Typography component="div" className="kpi-value" sx={{ fontSize: 28, fontWeight: 700, lineHeight: 1.15, mt: 0.25, color: dsColorNew.textTitle }}>
				<CountUpSeeker end={countUp}/>
			</Typography>
		</Box>
	</CardSeeker>
}
